// Category Service
// This service handles all API communications for categories

const API_BASE_URL = process.env.REACT_APP_API_URL || '/.netlify/functions';

class CategoryService {
  async getAll() {
    try {
      const response = await fetch(`${API_BASE_URL}/categoriesCRUD`);
      if (!response.ok) {
        throw new Error('Failed to fetch categories');
      }
      const result = await response.json();
      return result.success ? result.data : [];
    } catch (error) {
      console.error('CategoryService.getAll error:', error);
    }
  }

  async getById(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/categoriesCRUD?id=${id}`);
      if (!response.ok) {
        throw new Error('Failed to fetch category');
      }
      const result = await response.json();
      return result.success ? result.data : null;
    } catch (error) {
      console.error('CategoryService.getById error:', error);
      throw error;
    }
  }

}

export const categoryService = new CategoryService();
